import React from 'react';
import { assets } from '../../assets/branding';

// Subtle corporate-endorsement + trust strip. Understated by design — it must
// never visually compete with the ReasonVisionX product identity.
// Uses the official REASON parent-company logo; DPIIT + Made-in-India are shown
// as clean text credentials (no fabricated government emblem). Official DPIIT /
// Made-in-India graphics can be slotted via assets.dpiitBadge / madeInIndiaBadge.
const Dot = () => <span className="w-1 h-1 rounded-full bg-border shrink-0" aria-hidden="true" />;

export const TrustStrip = ({ className = '', onDark = false }) => {
  const base = onDark ? 'text-white/70' : 'text-muted-foreground/80';
  return (
    <div
      className={`flex flex-wrap justify-center items-center gap-x-3 gap-y-2 w-full ${className}`}
      data-testid="trust-strip"
      role="contentinfo"
      aria-label="A product by REASON. DPIIT Recognised Startup. Made in India."
    >
      <span className={`inline-flex items-center gap-1.5 text-xs font-medium tracking-wide ${base}`}>
        A product by
        <span className={onDark ? 'bg-white/95 rounded px-1.5 py-0.5 inline-flex' : 'inline-flex'}>
          <img src={assets.reasonCorporateLogo} alt="REASON" className="h-4 w-auto object-contain" data-testid="reason-corporate-logo" />
        </span>
      </span>
      <Dot />
      <span className={`text-xs font-medium tracking-wide ${base}`} data-testid="trust-dpiit">
        DPIIT Recognised Startup
      </span>
      <Dot />
      <span className={`inline-flex items-center gap-1.5 text-xs font-medium tracking-wide ${base}`} data-testid="trust-made-in-india">
        <span className="inline-block h-3 w-4 rounded-sm overflow-hidden shrink-0 border border-black/5" aria-hidden="true">
          <span className="block h-1/3 bg-[#FF9933]" />
          <span className="block h-1/3 bg-white" />
          <span className="block h-1/3 bg-[#138808]" />
        </span>
        Made in India
      </span>
    </div>
  );
};

export default TrustStrip;
